export type ChatVersion = 'v1' | 'v2';

declare global {
  interface Window {
    CHAT_V1_ROLLBACK_ENTERPRISES?: string | number[];
    __CHAT_VERSION__?: ChatVersion;
  }
}

export function getChatVersion(enterpriseId?: string | number): ChatVersion {
  const raw = window.CHAT_V1_ROLLBACK_ENTERPRISES;
  // 兼容两种来源：MSE(Nacos) 下发的 JSON 数组（如 [9002162, 9003613]）
  // 与构建时兜底注入的逗号分隔字符串（如 "9002162,9003613"，也兼容 JSON 字符串）
  let source: unknown = raw;
  if (typeof source === 'string') {
    try {
      source = JSON.parse(source);
    } catch {
      source = source.split(',');
    }
  }
  const rollback = (Array.isArray(source) ? source : source == null ? [] : [source])
    .map((s) => String(s).trim())
    .filter(Boolean);
  // 默认 v2；只有在回退名单里的企业走 v1
  return enterpriseId != null && rollback.includes(String(enterpriseId)) ? 'v1' : 'v2';
}

// 给深层 store 用，避免散落 window.__CHAT_VERSION__ 字面量
export function getCurrentChatVersion(): ChatVersion {
  return window.__CHAT_VERSION__ || 'v2';
}
